/* MERGED FILE GENERATED: Base = ViewOtherProfilePage copy 3.jsx + Contact Unlock logic */
import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import profileService from "../../services/profileService";
import advertisementService from "../../services/advertisementService";
import advertisementResponseService from "../../services/advertisementResponseService";
import creditService from "../../services/creditService";

import Typography from "@mui/material/Typography";
import MemberLayout from "../../shared/layouts/MemberLayout";
import CollapsibleSection from "../../shared/components/CollapsibleSection";
import PromptModal from "../../shared/components/PromptModal";
import { designClasses } from "../../shared/styles/designTokens";

// Material-UI components for custom message and feedback
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import BasicProfile from "./components/sections/BasicProfile";

import EducationJobDetails from "./components/sections/EducationJobDetails";
import FamilyDetails from "./components/sections/FamilyDetails";
import HoroscopeDetails from "./components/sections/HoroscopeDetails";
import ReferencesSection from "./components/sections/ReferencesSection";
import countryData from 'country-telephone-data';


const FALLBACK_DEFAULT_IMAGE_PATH =
  "/ProfilePhotos/defaultImage.jpg";

const ViewOtherProfilePage = () => {
  const { profileId } = useParams();
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSection, setActiveSection] = useState("personal");
  const [inviterMessage, setInviterMessage] = useState(''); // State for custom message
  const [isSendingInvitation, setIsSendingInvitation] = useState(false); // State for button loading
  const [snackbarOpen, setSnackbarOpen] = useState(false); // State for Snackbar feedback
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [
    creditSummary,
    setCreditSummary,
  ] = useState(null);

  const [
    actionLoading,
    setActionLoading,
  ] = useState(false);
  const [
    advertisementResponseSubmitted,
    setAdvertisementResponseSubmitted,
  ] = useState(false);
  const [
    promptModal,
    setPromptModal,
  ] = useState({
    open: false,
    title: "",
    description: "",
    label: "Remarks",
    initialValue: "",
    placeholder: "",
    required: false,
    confirmLabel: "Submit",
    showCreditSummary: false,
    actionCost: 0,
    onConfirm: null,
  });

  const closePromptModal =
    () => {
      setPromptModal(
        (current) => ({
          ...current,
          open: false,
          onConfirm: null,
        })
      );
    };

  const openPromptModal =
    (options) => {
      setPromptModal({
        open: true,
        title:
          options?.title || "",
        description:
          options?.description || "",
        label:
          options?.label || "Remarks",
        initialValue:
          options?.initialValue || "",
        placeholder:
          options?.placeholder || "",
        required:
          Boolean(
            options?.required
          ),
        confirmLabel:
          options?.confirmLabel ||
          "Submit",
        showCreditSummary:
          Boolean(
            options?.showCreditSummary
          ),
        actionCost:
          Number(
            options?.actionCost || 0
          ),
        onConfirm:
          options?.onConfirm || null,
      });
    };

  // Protected contact access.
  // Advertisement Mutual Interest may reveal
  // the permitted phone number directly.
  // Legacy non-advertisement contact handling
  // remains supported by the backend.
  const [contactData, setContactData] = useState(null);
  const [contactLoading, setContactLoading] = useState(false);

  const [
    contactAccessChecked,
    setContactAccessChecked,
  ] = useState(false);

  const [
    contactAccessStatus,
    setContactAccessStatus,
  ] = useState("");

  // Carousel state (ONLY in ViewOtherProfilePage)
  const [photos, setPhotos] = useState([]); // normalized: [{ id, fullUrl, blobName }]
  const [activeIndex, setActiveIndex] = useState(0);
  const [photosLoading, setPhotosLoading] = useState(false);
  const [photosError, setPhotosError] = useState('');
  const [, setBrokenUrls] = useState(() => new Set());

  const mergedProfileData = useMemo(() => {
  if (!profileData) return null;

  const merged = contactData ? { ...profileData, ...contactData } : profileData;

    // ---------- ADDRESS SPLIT (align with MyProfilePage save order) ----------
  // MyProfilePage stores: house, street, area, city, state, country, pin
  const splitAddressSmart = (addressString = '', prefix = 'communication') => {
    if (!addressString || typeof addressString !== 'string') return {};

    const parts = addressString.split(',').map(p => p.trim()).filter(Boolean);

    // Default mapping (7-part): house, street, area, city, state, country, pin  Ã¢Å“â€¦ (matches MyProfilePage)
    let house = parts[0] || '';
    let street = parts[1] || '';
    let area = parts[2] || '';
    let city = parts[3] || '';
    let state = parts[4] || '';
    let country = parts[5] || '';
    let pin = parts[6] || '';

    // Handle 5-part format: house, street, area, city, pin
    // Example: "405, road10, hoskerihalli, Bengaluru, 560098"
    if (parts.length === 5) {
      const last = parts[4] || '';
      const fourth = parts[3] || '';
      const isLastNumeric = /^\d{4,10}$/.test(last);
      if (isLastNumeric) {
        house = parts[0] || '';
        street = parts[1] || '';
        area = parts[2] || '';
        city = fourth || '';
        pin = last || '';
        state = '';
        country = '';
      }
    }

    return {
      [`${prefix}HouseNo`]: house,
      [`${prefix}Street`]: street,
      [`${prefix}Area`]: area,
      // IMPORTANT: AddressDetails.jsx expects PIN uppercase
      [`${prefix}PIN`]: pin,
      [`${prefix}City`]: city,
      [`${prefix}State`]: state,
      [`${prefix}Country`]: country
    };
  };

  const commAddr = merged.communication_address || merged.communicationAddress || '';
  const resAddr  = merged.residence_address || merged.residenceAddress || '';

  const withAddress = {
    ...merged,

    // Keep full strings for fallback rows
    communicationAddress: merged.communicationAddress || merged.communication_address || '',
    residenceAddress: merged.residenceAddress || merged.residence_address || '',

    // Split fields for AddressDetails view-mode
    ...splitAddressSmart(commAddr, 'communication'),
    ...splitAddressSmart(resAddr, 'residence')
  };

  // ---------- PHONE SPLITTING ----------
    // ---------- PHONE SPLITTING (align with MyProfilePage) ----------
  const parsePhoneNumberForInput = (fullNumberString) => {
    if (!fullNumberString || typeof fullNumberString !== 'string') {
      return { code: '', number: '' };
    }

    // Normalize common separators (spaces, hyphens, brackets)
    let s = fullNumberString.trim().replace(/[\s\-()]/g, '');

    let bestMatchCode = '';
    let bestMatchNumber = s;

    const sortedCountryCodes = countryData.allCountries
      .map(c => `+${c.dialCode}`)
      .sort((a, b) => b.length - a.length); // longest first

    for (const dialCode of sortedCountryCodes) {
      // Stored like +9198...
      if (s.startsWith(dialCode)) {
        bestMatchCode = dialCode;
        bestMatchNumber = s.substring(dialCode.length);
        break;
      }
      // Stored like 9198... (without +)
      if (dialCode.startsWith('+') && s.startsWith(dialCode.substring(1))) {
        bestMatchCode = dialCode;
        bestMatchNumber = s.substring(dialCode.length - 1);
        break;
      }
    }

    // Fallback
    if (!bestMatchCode) {
      bestMatchCode = '+91';
      bestMatchNumber = s.replace(/^\+/, '');
    }

    return { code: bestMatchCode, number: (bestMatchNumber || '').trim() };
  };

  const mainPhone = parsePhoneNumberForInput(withAddress.phone || withAddress.phoneNumber);
  const altPhone = parsePhoneNumberForInput(
    withAddress.alternate_phone || withAddress.alternatePhone || withAddress.alternatePhoneNumber
  );
  const guardianPhone = parsePhoneNumberForInput(
    withAddress.guardian_phone || withAddress.guardianPhone || withAddress.guardianPhoneNumber
  );

  return {
    ...withAddress,
    phoneCountryCode: withAddress.phoneCountryCode || mainPhone.code || '',
    phoneNumber: withAddress.phoneNumber || mainPhone.number || '',

    alternatePhoneCountryCode: withAddress.alternatePhoneCountryCode || altPhone.code || '',
    alternatePhoneNumber: withAddress.alternatePhoneNumber || altPhone.number || '',

    guardianPhoneCountryCode: withAddress.guardianPhoneCountryCode || guardianPhone.code || '',
    guardianPhoneNumber: withAddress.guardianPhoneNumber || guardianPhone.number || ''
  };

}, [profileData, contactData]);


  const toggleSection = (sectionId) => {
  setActiveSection((current) =>
    current === sectionId ? null : sectionId
  );
};

  // added on 31-Dec-25 for handling
  const location = useLocation();
  const profileContext =
    useMemo(() => {
      const params =
        new URLSearchParams(
          location.search
        );

      return {
        source:
          String(
            params.get(
              "source"
            ) || "standard"
          )
            .trim()
            .toLowerCase(),

        advertisementId:
          params.get(
            "advertisementId"
          ) || "",

        responseId:
          params.get(
            "responseId"
          ) || "",

        responseType:
          String(
            params.get(
              "responseType"
            ) || ""
          )
            .trim()
            .toUpperCase(),

        responseStatus:
          String(
            params.get(
              "responseStatus"
            ) || ""
          )
            .trim()
            .toUpperCase(),

        direction:
          String(
            params.get(
              "direction"
            ) || ""
          )
            .trim()
            .toLowerCase(),

        returnTo:
          params.get(
            "returnTo"
          ) || ""
      };
    }, [
      location.search
    ]);
  const isAdvertisementContext =
    profileContext.source ===
      "advertisement" &&
    Boolean(
      profileContext
        .advertisementId
    );

  const isAdvertisementResponseContext =
    profileContext.source ===
      "message-box" &&
    Boolean(
      profileContext
        .responseId
    );

  const isMutualContext =
    profileContext
      .responseStatus ===
    "MUTUAL";

  const isReceivedResponse =
    profileContext.direction ===
    "received";

  const isSentResponse =
    profileContext.direction ===
    "sent";
  const canShortlistResponse =
    isAdvertisementResponseContext &&
    isReceivedResponse &&
    profileContext
      .responseType ===
      "INTEREST" &&
    (
      profileContext
        .responseStatus ===
        "NEW" ||
      profileContext
        .responseStatus ===
        "HOLD"
    );

  const canApplyAfterShortlist =
    isAdvertisementResponseContext &&
    isSentResponse &&
    profileContext
      .responseType ===
      "INTEREST" &&
    profileContext
      .responseStatus ===
      "SHORTLISTED";

  const canConfirmMutual =
    isAdvertisementResponseContext &&
    isReceivedResponse &&
    profileContext
      .responseStatus !==
      "MUTUAL" &&
    (
      profileContext
        .responseType ===
        "APPLY" ||
      profileContext
        .responseStatus ===
        "APPLIED"
    );
  useEffect(() => {
    const params =
      new URLSearchParams(
        location.search
      );

    const requestedSection =
      params.get("section");

    if (
      requestedSection === "contact"
    ) {
      setActiveSection("contact");

      window.setTimeout(() => {
        document
          .getElementById(
            "profile-contact-section"
          )
          ?.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
      }, 150);
    }
  }, [location.search]);

  const handleReturn = () => {
    const params = new URLSearchParams(location.search);
    const returnTo = params.get("returnTo"); // e.g. "/dashboard" or "/basic-search"

    // If opened in a new tab via window.open, close works (browser allows)
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }

    // If caller provided a return path, use it
    if (returnTo) {
      navigate(returnTo);
      return;
    }

    // Otherwise try browser back
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    // Fallback
    navigate("/dashboard");
  };
  
    useEffect(() => {
    let active = true;

    const loadCreditSummary =
      async () => {
        try {
          const summary =
            await creditService
              .getMyCreditSummary();

          if (active) {
            setCreditSummary(
              summary
            );
          }
        } catch (creditError) {
          console.error(
            "Unable to load credit summary:",
            creditError
          );

          if (active) {
            setCreditSummary(
              null
            );
          }
        }
      };

    loadCreditSummary();

    return () => {
      active = false;
    };
  }, []);

  const refreshCreditSummary =
    async () => {
      try {
        const summary =
          await creditService
            .getMyCreditSummary();

        setCreditSummary(
          summary
        );
      } catch (creditError) {
        console.error(
          "Unable to refresh credit balance:",
          creditError
        );
      }
    };

  const updateProfileContextStatus =
    (responseStatus) => {
      const params =
        new URLSearchParams(
          location.search
        );

      params.set(
        "responseStatus",
        String(
          responseStatus || ""
        ).toUpperCase()
      );

      navigate(
        `${location.pathname}?${params.toString()}`,
        {
          replace: true
        }
      );
    };
    
  useEffect(() => {
    const fetchProfile = async () => {
      if (!profileId) {
        setError("Profile ID is missing from the URL.");
        setLoading(false);
        return;
      }

setLoading(true);
setError(null);

try {
  const data =
    await profileService.getProfileById(profileId);

  if (!data) {
          setError("Profile not found.");
          setProfileData(null);
        } else {
          
          //setProfileData(response.data);
          const raw = data || {};

// ===============================
// ADDRESS SPLITTING LOGIC
// ===============================
const splitAddress = (addressString = '') => {
  if (!addressString || typeof addressString !== 'string') {
    return {};
  }

  const parts = addressString.split(',').map(p => p.trim());

   return {
    communicationHouseNo: parts[0] || '',
    communicationStreet: parts[1] || '',
    communicationArea: parts[2] || '',
    communicationCity: parts[3] || '',
    communicationState: parts[4] || '',
    communicationCountry: parts[5] || '',
    communicationPIN: parts[6] || ''   // Ã¢Å“â€¦ uppercase PIN
  };

};

// ===============================
// PHONE SPLITTING LOGIC
// ===============================
const splitPhone = (value) => {
  if (!value) return { code: '', number: '' };

  const s = String(value).trim();
  const m = s.match(/^(\+\d{1,4})(\d{6,})$/);

  if (m) return { code: m[1], number: m[2] };

  return { code: '', number: s };
};

const mainPhone = splitPhone(raw.phone);
const altPhone = splitPhone(raw.alternate_phone);
const guardianPhone = splitPhone(raw.guardian_phone);

const normalized = {
  ...raw,

  // ===============================
  // ADDRESS
  // ===============================
  communicationAddress: raw.communication_address,
  ...splitAddress(raw.communication_address),

  residenceAddress: raw.residence_address,

  // ===============================
  // PHONE
  // ===============================
  phoneCountryCode: mainPhone.code,
  phoneNumber: mainPhone.number,

  alternatePhoneCountryCode: altPhone.code,
  alternatePhoneNumber: altPhone.number,

  guardianPhoneCountryCode: guardianPhone.code,
  guardianPhoneNumber: guardianPhone.number
};

setProfileData(normalized);

/*
 * Check whether contact access for this profile
 * was already approved by Moderator/Admin.
 *
 * Do not silently treat every failure as
 * "not approved". Preserve the actual state
 * so the member sees the correct behaviour.
 */
setContactAccessChecked(false);
setContactAccessStatus("");
setContactData(null);

try {
  const approvedContact =
    await profileService.getContactDetails(
      profileId
    );

  if (approvedContact) {
    setContactData(
      approvedContact
    );

    setContactAccessStatus(
      "APPROVED"
    );
  } else {
    setContactData(null);
    setContactAccessStatus("");
  }
} catch (contactError) {
  const httpStatus =
    contactError?.response?.status;

  const backendMessage =
    contactError?.response?.data
      ?.message ||
    "";

  if (httpStatus === 403) {
    setContactData(null);

    setContactAccessStatus(
      "NOT_APPROVED"
    );
  } else if (httpStatus === 404) {
    setContactData(null);

    setContactAccessStatus(
      "NOT_FOUND"
    );
  } else {
    console.error(
      "[ViewOtherProfilePage] Unable to check approved contact access:",
      contactError
    );

    setContactData(null);

    setContactAccessStatus(
      "ERROR"
    );

    setSnackbarMessage(
      backendMessage ||
        "Unable to verify contact access."
    );

    setSnackbarSeverity(
      "error"
    );

    setSnackbarOpen(true);
  }
} finally {
  setContactAccessChecked(true);
}
    }
      } catch (err) {
        console.error(
  "Unable to load profile:",
  err
);
        setError(err.message || "Failed to load profile.");
        if (err.response?.status === 401) {
          navigate('/login');
        } else if (err.response?.status === 404) {
          setError("Profile not found.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [profileId, navigate]);

  // Ã¢Å“â€¦ Load photos (restore copy behavior + robust URL handling)
// Ã¢Å“â€¦ Load photos (copy behavior, but FIXED for url_path + windows photo_path)
useEffect(() => {
  if (!profileData) return;

  const pid = profileData.profile_id || profileData.profileId;
  if (!pid) {
    console.warn("[ViewOtherProfilePage] profileData missing profile_id/profileId. Using fallback photo.");
    setPhotos([{ id: null, fullUrl: FALLBACK_DEFAULT_IMAGE_PATH, blobName: "" }]);
    setActiveIndex(0);
    setPhotosError("");
    return;
  }

  let cancelled = false;

  const normalizePhoto = (p) => {
    if (!p) return null;

    const idVal = p.id ?? p.photo_id ?? p.photoId ?? null;

    // Ã¢Å“â€¦ Prefer url_path FIRST (your backend returns correct /profilePhotos/...)
    // Avoid using photo_path if it's a Windows disk path
    let fullUrl =
      p.url_path ??
      p.fullUrl ??
      p.urlPath ??
      "";

    const filename = p.filename ?? p.blob_name ?? p.blobName ?? "";

    // If url_path missing but filename exists, fallback to /profilePhotos/<filename>
    if (!fullUrl && filename) {
      fullUrl = `/profilePhotos/${filename}`;
    }

    // If somehow fullUrl is a Windows path, ignore it and use filename fallback
    if (fullUrl && /^[a-zA-Z]:\\/.test(fullUrl)) {
      fullUrl = filename ? `/profilePhotos/${filename}` : "";
    }

    if (fullUrl && !/^https?:\/\//i.test(fullUrl)) {
  fullUrl =
    fullUrl.startsWith("/")
      ? fullUrl
      : `/${fullUrl}`;
}

    return {
      id: idVal ?? filename ?? Math.random(),
      blobName: filename,
      fullUrl: fullUrl || FALLBACK_DEFAULT_IMAGE_PATH,
    };
  };

  const loadCarousel = async () => {
    
    setPhotosLoading(true);
    setPhotosError("");
    setBrokenUrls(new Set());
    setActiveIndex(0);
    setPhotos([]);

    try {
  const list =
    await profileService.getProfilePhotos(pid);

  const normalized = list
    .map(normalizePhoto)
    .filter((photo) => photo?.fullUrl);

  if (cancelled) {
    return;
  }

  if (normalized.length > 0) {
    setPhotos(normalized);
    return;
  }

  const defaultPhoto =
    await profileService.getDefaultPhoto(pid);

  if (cancelled) {
    return;
  }

  const normalizedDefault =
    normalizePhoto(defaultPhoto);

  if (normalizedDefault?.fullUrl) {
    setPhotos([normalizedDefault]);
  } else {
    setPhotos([
      {
        id: null,
        fullUrl: FALLBACK_DEFAULT_IMAGE_PATH,
        blobName: "",
      },
    ]);

    setPhotosError(
      "Photos not available for this profile."
    );
  }
    } catch (err) {
      if (cancelled) return;
      console.error("Ã¢ÂÅ' [ViewOtherProfilePage] Failed to load photos:", err);
      setPhotos([{ id: null, fullUrl: FALLBACK_DEFAULT_IMAGE_PATH, blobName: "" }]);
      setPhotosError("Failed to load photos.");
    } finally {
      if (!cancelled) setPhotosLoading(false);
    }
  };

  loadCarousel();

  return () => {
    cancelled = true;
  };
}, [profileData]);

  const handleUnlockContactDetails = async () => {
    if (!profileData) return;

    setContactLoading(true);

    try {
      const payload = {
        sharedProfileId:
          profileData.profile_id ||
          profileId,

        sharedProfileName:
          profileData.name ||
          "",

        requestSource:
          isMutualContext
            ? "ADVERTISEMENT_MUTUAL"
            : "PROFILE"
      };

const data =
  await profileService.shareContactDetails(
    payload
  );

const requestStatus = (
  data?.status || ""
).toUpperCase();

if (
  !isMutualContext &&
  (
    requestStatus ===
      "PENDING" ||
    requestStatus ===
      "CLARIFICATION_REQUIRED"
  )
) {
  setContactData(null);
  setContactAccessChecked(true);
  setContactAccessStatus(
    requestStatus
  );

  setSnackbarMessage(
    data?.message ||
      "Contact request submitted for moderator review."
  );

  setSnackbarSeverity("info");
  setSnackbarOpen(true);
  return;
}

// If access was previously approved,
// backend returns the contact data directly.
setContactData(
  data?.contact || null
);
setContactAccessChecked(true);
setContactAccessStatus(
  "APPROVED"
);
setActiveSection("contact");

setSnackbarMessage(
  "Phone number is available."
);

setSnackbarSeverity("success");
setSnackbarOpen(true);

    } catch (err) {
      console.error(
        "[ViewOtherProfilePage] Error unlocking contact details:",
        err
      );

      if (
        err.response?.status ===
          402 ||
        err.response?.data
          ?.code ===
          "INSUFFICIENT_CREDITS"
      ) {
        const responseData =
          err.response?.data || {};

        const available =
          responseData
            ?.availableBalance ??
          responseData?.data
            ?.availableBalance;

        const required =
          responseData
            ?.requiredCredits ??
          responseData?.data
            ?.requiredCredits;

        setSnackbarMessage(
          `Insufficient credits.${
            available !== undefined
              ? ` Available: ${available}.`
              : ""
          }${
            required !== undefined
              ? ` Required: ${required}.`
              : ""
          } Please recharge to continue.`
        );

        setSnackbarSeverity(
          "error"
        );

        setSnackbarOpen(true);
        return;
      }

      if (
        err.response?.status ===
          403
      ) {
        const data = err.response.data || {};
        const limit = data.limit;
        const used = data.used;

        let msg = data.message
          ? data.message
          : 'You have reached the contact view limit. Please recharge to view more profiles.';

        const parts = [];
        if (used !== undefined) parts.push(`Used: ${used}`);
        if (limit !== undefined) parts.push(`Limit: ${limit}`);
        if (parts.length > 0) msg = `${msg} (${parts.join(', ')})`;

        setSnackbarMessage(msg);
      } else if (err.response?.status === 401) {
        setSnackbarMessage('Authentication required. Please log in again.');
        navigate('/login');
      } else {
        setSnackbarMessage(err.response?.data?.message || err.message || 'Failed to unlock contact details.');
      }

      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setContactLoading(false);
    }
  };
  const handleAdvertisementResponse =
    (responseType) => {
      const advertisementId =
        profileContext
          .advertisementId;

      if (!advertisementId) {
        setSnackbarMessage(
          "Advertisement reference is unavailable."
        );
        setSnackbarSeverity(
          "error"
        );
        setSnackbarOpen(true);
        return;
      }

      const normalizedResponseType =
        String(
          responseType || ""
        )
          .trim()
          .toUpperCase();

      const actionCost =
        normalizedResponseType ===
          "APPLY"
          ? Number(
              creditSummary
                ?.actionCosts
                ?.directApply ||
              0
            )
          : Number(
              creditSummary
                ?.actionCosts
                ?.showInterest ||
              0
            );

      openPromptModal({
        title:
          normalizedResponseType ===
            "APPLY"
            ? "Apply for this Profile"
            : "Show Interest",

        description:
          normalizedResponseType ===
            "APPLY"
            ? "Please provide a genuine reason for applying to this matrimonial profile."
            : "Show Interest means this profile appears potentially suitable, but you need clarification or additional information before applying. Please explain what you would like to understand.",

        label:
          normalizedResponseType ===
            "APPLY"
            ? "Reason for Applying"
            : "Reason / Clarification Required",

        placeholder:
          normalizedResponseType ===
            "APPLY"
            ? "Explain why you believe the profiles may be suitable..."
            : "Example: The profile appears suitable, but we would like to understand willingness to relocate before applying...",

        required:
          true,

        confirmLabel:
          normalizedResponseType ===
            "APPLY"
            ? "Submit Application"
            : "Send Interest",

        showCreditSummary:
          true,

        actionCost,

        onConfirm:
          async (remarks) => {
            closePromptModal();

            try {
              setActionLoading(
                true
              );

              const result =
                await advertisementService
                  .respondToAdvertisement({
                    advertisementId,
                    responseType:
                      normalizedResponseType,
                    remarks,
                  });

              await refreshCreditSummary();

              setAdvertisementResponseSubmitted(
                true
              );

              setSnackbarMessage(
                result?.message ||
                  "Response submitted successfully."
              );

              setSnackbarSeverity(
                "success"
              );

              setSnackbarOpen(true);
            } catch (requestError) {
              console.error(
                "Unable to submit advertisement response:",
                requestError
              );

              setSnackbarMessage(
                requestError?.response
                  ?.data?.message ||
                  "Unable to submit the response."
              );

              setSnackbarSeverity(
                "error"
              );

              setSnackbarOpen(true);
            } finally {
              setActionLoading(
                false
              );
            }
          },
      });
    };
  const handleApplyAfterShortlist =
    () => {
      if (
        !profileContext.responseId
      ) {
        return;
      }

      openPromptModal({
        title:
          "Apply for this Advertisement",

        description:
          "Provide the requested clarification and confirm that you would like to proceed.",

        label:
          "Your Clarification / Application Message",

        placeholder:
          "Provide the requested clarification and any additional information you would like the profile owner to consider.",

        required:
          true,

        confirmLabel:
          "Submit Application",

        showCreditSummary:
          true,

        actionCost:
          Number(
            creditSummary
              ?.actionCosts
              ?.directApply ||
            0
          ),

        onConfirm:
          async (remarks) => {
            closePromptModal();

            try {
              setActionLoading(
                true
              );

              await advertisementResponseService
                .applyAfterShortlist({
                  responseId:
                    profileContext
                      .responseId,
                  remarks,
                });

              await refreshCreditSummary();

              updateProfileContextStatus(
                "APPLIED"
              );

              setSnackbarMessage(
                "Application submitted successfully."
              );

              setSnackbarSeverity(
                "success"
              );

              setSnackbarOpen(true);
            } catch (requestError) {
              console.error(
                "Unable to submit application:",
                requestError
              );

              setSnackbarMessage(
                requestError?.response
                  ?.data?.message ||
                  "Unable to submit the application."
              );

              setSnackbarSeverity(
                "error"
              );

              setSnackbarOpen(true);
            } finally {
              setActionLoading(
                false
              );
            }
          },
      });
    };
  const handleResponseStatus =
    (
      responseStatus
    ) => {
      if (
        !profileContext.responseId
      ) {
        return;
      }

      const actionCost =
        responseStatus ===
          "SHORTLISTED"
          ? Number(
              creditSummary
                ?.actionCosts
                ?.shortlist ||
              0
            )
          : responseStatus ===
              "MUTUAL"
            ? Number(
                creditSummary
                  ?.actionCosts
                  ?.mutualInterest ||
                0
              )
            : 0;

      openPromptModal({
        title:
          responseStatus ===
            "MUTUAL"
            ? "Confirm Mutual Interest"
            : "Shortlist Profile",

        description:
          responseStatus ===
            "MUTUAL"
            ? "Confirm that you would like to proceed with this member."
            : "Please specify the clarification or additional information you require before this member applies.",

        label:
          responseStatus ===
            "SHORTLISTED"
            ? "Clarification / Additional Information Required"
            : "Remarks",

        initialValue:
          responseStatus ===
            "MUTUAL"
            ? "I would like to proceed with this profile."
            : "",

        required:
          true,

        confirmLabel:
          responseStatus ===
            "MUTUAL"
            ? "Confirm Mutual Interest"
            : "Send Clarification Request",

        showCreditSummary:
          true,

        actionCost,

        onConfirm:
          async (remarks) => {
            closePromptModal();

            try {
              setActionLoading(
                true
              );

              await advertisementResponseService
                .updateResponseStatus({
                  responseId:
                    profileContext
                      .responseId,
                  responseStatus,
                  remarks,
                });

              await refreshCreditSummary();

              updateProfileContextStatus(
                responseStatus
              );

              setSnackbarMessage(
                responseStatus ===
                  "MUTUAL"
                  ? "Mutual Interest confirmed."
                  : "Clarification request sent."
              );

              setSnackbarSeverity(
                "success"
              );

              setSnackbarOpen(true);
            } catch (requestError) {
              console.error(
                "Unable to update response:",
                requestError
              );

              setSnackbarMessage(
                requestError?.response
                  ?.data?.message ||
                  "Unable to update the response."
              );

              setSnackbarSeverity(
                "error"
              );

              setSnackbarOpen(true);
            } finally {
              setActionLoading(
                false
              );
            }
          },
      });
    };
  const handleSendInvitation = async () => {
    setIsSendingInvitation(true);
    try {
      setSnackbarMessage("Invitation flow unchanged (not modified here).");
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
    } finally {
      setIsSendingInvitation(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Typography variant="h6">Loading profile...</Typography>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3">
        <Typography variant="h6" color="error">{error}</Typography>
        <button
          className={`rounded-lg px-6 py-2 font-semibold transition ${designClasses.secondaryButton}`}
          onClick={handleReturn}
        >
          Close and Return
        </button>
      </div>
    );
  }

  if (!profileData) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3">
        <Typography variant="h6">Profile not found.</Typography>

        <button
          type="button"
          className={`rounded-lg px-6 py-2 font-semibold transition ${designClasses.secondaryButton}`}
          onClick={handleReturn}
        >
          Close and Return
        </button>
      </div>
    );
  }

  return (
    <MemberLayout>
      <div className="w-full space-y-6">

        {/* Profile Header */}
        <div
          className={`overflow-hidden rounded-2xl border ${designClasses.border} ${designClasses.surface}`}
        >
          <div className={`border-b p-5 sm:p-6 ${designClasses.border}`}>
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h1
                  className={`text-2xl font-bold ${designClasses.textPrimary}`}
                >
                  View Profile
                </h1>

                <p
                  className={`mt-1 text-sm ${designClasses.textSecondary}`}
                >
                  Review profile information and connect with this member.
                </p>
              </div>

              <div className="text-sm">
                <div className={designClasses.textSecondary}>
                  Profile ID
                </div>

                <div
                  className={`font-semibold ${designClasses.textPrimary}`}
                >
                  {profileData.profile_id || profileId || "-"}
                </div>
              </div>
            </div>
          </div>

          {/* Photos */}
          <div className="p-5 sm:p-6">
            <div className="mb-4 flex items-center justify-between">
              <div>
                <h2
                  className={`text-lg font-semibold ${designClasses.textPrimary}`}
                >
                  Photos
                </h2>

                <p
                  className={`mt-1 text-sm ${designClasses.textSecondary}`}
                >
                  Profile photos shared by this member.
                </p>
              </div>

              {photosLoading && (
                <span className={`text-sm ${designClasses.textSecondary}`}>
                  Loading photos...
                </span>
              )}
            </div>

            {photosError ? (
              <div
  className={`rounded-lg p-3 text-sm ${designClasses.statusError}`}
  role="alert"
>
  {photosError}
</div>
            ) : (
              <div className="flex flex-col items-center">
                <div className="w-full max-w-md">
                  <img
                    src={
                      photos[activeIndex]?.fullUrl ||
                      FALLBACK_DEFAULT_IMAGE_PATH
                    }
                    alt="Profile"
                    className="h-80 w-full rounded-xl border object-cover"
                    onError={() =>
                      setBrokenUrls((prev) =>
                        new Set(prev).add(activeIndex)
                      )
                    }
                  />
                </div>

                {photos.length > 1 && (
                  <div className="mt-3 flex flex-wrap justify-center gap-2">
                    {photos.map((photo, index) => (
                      <button
                        key={photo.id || index}
                        type="button"
                        onClick={() => setActiveIndex(index)}
                        className={`h-14 w-14 overflow-hidden rounded-lg border ${
                          index === activeIndex
                            ? "border-[#D79A1E]"
                            : designClasses.border
                        }`}
                        title={`Photo ${index + 1}`}
                      >
                        <img
                          src={photo.fullUrl || FALLBACK_DEFAULT_IMAGE_PATH}
                          alt={`Profile ${index + 1}`}
                          className="h-full w-full object-cover"
                        />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Profile Sections */}
        <div className="space-y-4">
          <CollapsibleSection
            number={1}
            title="Personal Details"
            description="Basic profile and personal information."
            open={activeSection === "personal"}
            onToggle={() => toggleSection("personal")}
          >
            <BasicProfile profileData={profileData} />
          </CollapsibleSection>

          <div
            id="profile-contact-section"
            className="scroll-mt-4"
          >
          <CollapsibleSection
            number={2}
            title="Contact"
description="Protected phone contact information."
            open={activeSection === "contact"}
            onToggle={() => toggleSection("contact")}
          >
            {!contactAccessChecked ? (
              <div
                className={`rounded-lg p-4 text-sm ${designClasses.surfaceMuted} ${designClasses.textSecondary}`}
              >
                Checking approved contact access...
              </div>
            ) : contactAccessStatus ===
                "APPROVED" &&
              contactData ? (
              <div className="space-y-4">
                <div
                  className={`rounded-lg border p-3 text-sm ${designClasses.border}`}
                >
                  <span
                    className={`font-semibold ${designClasses.textPrimary}`}
                  >
                    Contact access approved.
                  </span>

                  <span
                    className={`ml-1 ${designClasses.textSecondary}`}
                  >
                    The permitted phone number
                    is available below.
                  </span>
                </div>

                <div
                  className={`rounded-xl border p-4 ${designClasses.border} ${designClasses.surfaceMuted}`}
                >
                  <p
                    className={`text-xs font-semibold uppercase tracking-wide ${designClasses.textSecondary}`}
                  >
                    Phone Number
                  </p>

                  <p
                    className={`mt-1 text-lg font-semibold ${designClasses.textPrimary}`}
                  >
                    {contactData?.phone ||
                      "Phone number unavailable"}
                  </p>
                </div>
              </div>
            ) : contactAccessStatus ===
              "ERROR" ? (
              <div
                className={`rounded-lg p-4 text-sm ${designClasses.statusError}`}
              >
                We could not verify your
                approved contact access.
                Please refresh and try again.
              </div>
            ) : (
              <div className="space-y-4">
                <p
                  className={`text-sm ${designClasses.textSecondary}`}
                >
                  Phone numbers are protected.
                  Contact access becomes available
                  after Mutual Interest. The
                  configured contact-view credit
                  cost will be used when the phone
                  number is unlocked.
                </p>

                <Button
                  variant="contained"
                  onClick={
                    handleUnlockContactDetails
                  }
                  disabled={contactLoading}
                >
                  {contactLoading
                    ? "Submitting..."
                    : "View Phone Number"}
                </Button>
              </div>
            )}
          </CollapsibleSection>
          </div>

          <CollapsibleSection
            number={3}
            title="Education & Career"
            description="Education, profession and employment details."
            open={activeSection === "career"}
            onToggle={() => toggleSection("career")}
          >
            <EducationJobDetails profileData={profileData} />
          </CollapsibleSection>

          <CollapsibleSection
            number={4}
            title="Family Details"
            description="Family background and family information."
            open={activeSection === "family"}
            onToggle={() => toggleSection("family")}
          >
            <FamilyDetails profileData={profileData} />
          </CollapsibleSection>

          <CollapsibleSection
            number={5}
            title="Horoscope & Cultural Details"
            description="Gotra, Rashi, Nakshatra and related information."
            open={activeSection === "horoscope"}
            onToggle={() => toggleSection("horoscope")}
          >
            <HoroscopeDetails profileData={profileData} />
          </CollapsibleSection>

          <CollapsibleSection
            number={6}
            title="References"
            description="Reference contact information."
            open={activeSection === "references"}
            onToggle={() => toggleSection("references")}
          >
            <ReferencesSection profileData={profileData} />
          </CollapsibleSection>
        </div>

        {/* Connect */}
        <div
          className={`rounded-2xl border p-5 sm:p-6 ${designClasses.border} ${designClasses.surface}`}
        >
          <h2
            className={`text-lg font-semibold ${designClasses.textPrimary}`}
          >
            {isMutualContext
              ? "Mutual Interest"
              : isAdvertisementContext
              ? "Advertisement Actions"
              : isAdvertisementResponseContext
              ? "Response Actions"
              : "Connect with this Profile"}
          </h2>

          <p
            className={`mb-4 mt-1 text-sm ${designClasses.textSecondary}`}
          >
            {isMutualContext
              ? "Mutual Interest has been confirmed. You may view the member's phone number."
              : isAdvertisementContext
              ? "Respond to this matrimonial advertisement."
              : isAdvertisementResponseContext
              ? "Review this profile in the context of the advertisement response."
              : "Send a message along with your interest."}
          </p>

          {!isAdvertisementContext &&
            !isAdvertisementResponseContext && (
            <TextField
              fullWidth
              multiline
              rows={3}
              value={
                inviterMessage
              }
              onChange={(e) =>
                setInviterMessage(
                  e.target.value
                )
              }
              placeholder="Type your message..."
              variant="outlined"
            />
          )}

          <div className="mt-4 flex flex-col justify-end gap-3 sm:flex-row">
            <button
              type="button"
              className={`rounded-lg px-6 py-2.5 font-semibold transition ${designClasses.secondaryButton}`}
              onClick={handleReturn}
            >
              Back
            </button>
            {isAdvertisementContext &&
              !advertisementResponseSubmitted && (
              <>
                <button
                  type="button"
                  disabled={
                    actionLoading
                  }
                  onClick={() =>
                    handleAdvertisementResponse(
                      "INTEREST"
                    )
                  }
                  className={`rounded-lg px-6 py-2.5 font-semibold transition ${designClasses.secondaryButton} disabled:cursor-not-allowed disabled:opacity-50`}
                >
                  Show Interest
                </button>

                <button
                  type="button"
                  disabled={
                    actionLoading
                  }
                  onClick={() =>
                    handleAdvertisementResponse(
                      "APPLY"
                    )
                  }
                  className={`rounded-lg px-6 py-2.5 font-semibold transition ${designClasses.primaryButton} disabled:cursor-not-allowed disabled:opacity-50`}
                >
                  Apply
                </button>
              </>
            )}
            {isAdvertisementContext &&
              advertisementResponseSubmitted && (
                <div
                  className={`rounded-lg px-4 py-2 text-sm ${designClasses.statusSuccess}`}
                >
                  Your response has been
                  submitted. You can follow
                  further activity from the
                  Message Box.
                </div>
              )}
            {canShortlistResponse && (
              <button
                type="button"
                disabled={
                  actionLoading
                }
                onClick={() =>
                  handleResponseStatus(
                    "SHORTLISTED"
                  )
                }
                className={`rounded-lg px-6 py-2.5 font-semibold transition ${designClasses.primaryButton} disabled:cursor-not-allowed disabled:opacity-50`}
              >
                Shortlist
              </button>
            )}

            {canApplyAfterShortlist && (
              <button
                type="button"
                disabled={
                  actionLoading
                }
                onClick={
                  handleApplyAfterShortlist
                }
                className={`rounded-lg px-6 py-2.5 font-semibold transition ${designClasses.primaryButton} disabled:cursor-not-allowed disabled:opacity-50`}
              >
                Apply / Respond to Clarification
              </button>
            )}

            {canConfirmMutual && (
              <button
                type="button"
                disabled={
                  actionLoading
                }
                onClick={() =>
                  handleResponseStatus(
                    "MUTUAL"
                  )
                }
                className={`rounded-lg px-6 py-2.5 font-semibold transition ${designClasses.primaryButton} disabled:cursor-not-allowed disabled:opacity-50`}
              >
                Mutual Interest
              </button>
            )}
            {isMutualContext && (
              <button
                type="button"
                onClick={() => {
                  setActiveSection(
                    "contact"
                  );

                  window.setTimeout(
                    () => {
                      document
                        .getElementById(
                          "profile-contact-section"
                        )
                        ?.scrollIntoView({
                          behavior:
                            "smooth",
                          block:
                            "start"
                        });
                    },
                    100
                  );
                }}
                className={`rounded-lg px-6 py-2.5 font-semibold transition ${designClasses.primaryButton}`}
              >
                View Phone Number
              </button>
            )}

            {!isAdvertisementContext &&
              !isAdvertisementResponseContext && (
              <button
                type="button"
                className={`rounded-lg px-6 py-2.5 font-semibold transition disabled:cursor-not-allowed disabled:opacity-60 ${designClasses.primaryButton}`}
                onClick={
                  handleSendInvitation
                }
                disabled={
                  isSendingInvitation
                }
              >
                {isSendingInvitation
                  ? "Sending..."
                  : "Show Interest"}
              </button>
            )}
          </div>
        </div>

        <PromptModal
          open={
            promptModal.open
          }
          title={
            promptModal.title
          }
          description={
            promptModal.description
          }
          label={
            promptModal.label
          }
          initialValue={
            promptModal.initialValue
          }
          placeholder={
            promptModal.placeholder
          }
          required={
            promptModal.required
          }
          confirmLabel={
            promptModal.confirmLabel
          }
          showCreditSummary={
            promptModal
              .showCreditSummary
          }
          actionCost={
            promptModal.actionCost
          }
          creditSummary={
            creditSummary
          }
          onRecharge={() => {
            closePromptModal();
            navigate(
              "/renew-profile"
            );
          }}
          onCancel={
            closePromptModal
          }
          onConfirm={(value) =>
            promptModal
              .onConfirm?.(
                value
              )
          }
        />  
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackbarOpen(false)}
        >
          <Alert
            severity={snackbarSeverity}
            onClose={() => setSnackbarOpen(false)}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </MemberLayout>
  );

};

export default ViewOtherProfilePage;
